const i18n = require('i18n');
const PSEvents = require('PSEvents');
const GenericEngine = require('../Generic/GenericEngine');

cc.Class({
    extends: cc.Component,

    properties: {
        key: '[locale-key-here]',
        splitter: '[splitter-without braces, if in loc-json it is like this {0}, then leave only 0',
        labels: [cc.Label],
        refreshSplitOnEditor: {
            default: false,
            notify: function() {
                if (this.labels.length) {
                    this.split();
                }
            }
        }
    },

    onLoad () {
        if (GenericEngine.isInitialized()) {
            this.split();
        } else {
            const handler = () => {
                PSEvents.unsubscribe(handler);
                this.split();
            };
            PSEvents.subscribe(PSEvents.COMMON_INITIALIZED, handler);
        }
    },

    split () {
        const text = i18n.t(this.key, { [this.splitter]: 'xxxx' });
        const splited = text.split('xxxx');

        splited.forEach((item, index) => {
            if (index < this.labels.length) {
                this.labels[index].string = item;
            }
        });
    }
});
